module.exports = __webpack_public_path__ + "static/wsj-9b05afdee41b375444cd14db3ce64269.png";